export const GET_ITEMS = "app/Items/GET_ITEMS";
export const GET_ITEMS_PENDING = "app/Items/GET_ITEMS_PENDING";
export const GET_ITEMS_SUCCESS = "app/Items/GET_ITEMS_SUCCESS";
export const GET_ITEMS_FAILURE = "app/Items/GET_ITEMS_FAILURE";
export const OPEN_ADD_MODEL = "app/Items/OPEN_ADD_MODEL";
export const ITEMS_EDIT_MODEL_START_FETCH =
  "app/Items/ITEMS_EDIT_MODEL_START_FETCH";
export const ITEMS_VIEW_MODEL_START_FETCH =
  "app/Items/ITEMS_VIEW_MODEL_START_FETCH";

export const ITEMS_CLOSE_ADD_MODAL = "app/Items/CLOSE_ADD_MODAL";
export const ITEMS_EDIT_MODAL_OPEN_AND_FETCH =
  "app/Items/EDIT_MODAL_OPEN_AND_FETCH";
export const ITEMS_CLOSE_EDIT_MODAL = "app/Items/CLOSE_EDIT_MODAL";
export const ITEMS_VIEW_MODAL_OPEN_AND_FETCH =
  "app/Items/VIEW_MODAL_OPEN_AND_FETCH";
export const ITEMS_MODAL_SET_ITEM = "app/Items/MODAL_SET_ITEM";
export const ITEMS_CLOSE_VIEW_MODAL = "app/Items/CLOSE_VIEW_MODAL";
export const ITEMS_OPEN_ADD_MODAL = "app/Items/ITEMS_OPEN_ADD_MODAL";

export const ITEM_SAVE_PENDING = "app/Items/ITEM_SAVE_PENDING";
export const ITEM_SAVE_SUCCESS = "app/Items/ITEM_SAVE_SUCCESS";
export const ITEM_SAVE_FAILURE = "app/Items/ITEM_SAVE_FAILURE";
export const ITEM_SAVE = "app/Items/ITEM_SAVE";

export const ITEM_EDIT_PENDING = "app/Items/ITEM_EDIT_PENDING";
export const ITEM_EDIT_SUCCESS = "app/Items/ITEM_EDIT_SUCCESS";
export const ITEM_EDIT_FAILURE = "app/Items/ITEM_EDIT_FAILURE";
export const ITEM_EDIT = "app/Items/ITEM_EDIT";

export const DELETE_ITEM_PENDING = "app/Items/DELETE_ITEM_PENDING";
export const DELETE_ITEM_SUCCESS = "app/Items/DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_FAILURE = "app/Items/DELETE_ITEM_FAILURE";
export const DELETE_ITEM = "app/Items/DELETE_ITEM";
